import React, { useEffect, useState } from 'react';
import './starYearInit.css';
import {
    resolveTutorDetailsStarAsset,
    tutorDetailsStarConfig,
} from './tutorDetailsStarConfig';

function StarYearInit(props) {
    const images = tutorDetailsStarConfig.images || {};

    return (
        <div className='page-content page-content-star'>
            <img src={resolveTutorDetailsStarAsset(images.title_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-top-title.png')} alt="img"/>
            <img src={resolveTutorDetailsStarAsset(images.top_three_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-top-three-img.png')} alt="img"/>
            <img src={resolveTutorDetailsStarAsset(images.ranking_list_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-list-img-2.png')} alt="img"/>
        </div>
    );
}

export default StarYearInit;
